export const SOCIAL_PROVIDERS = ['zernio', 'buffer', 'telegram'] as const;

export type SocialProviderType = (typeof SOCIAL_PROVIDERS)[number];
